export class SkipStageImpl {
    constructor(count) {
        this.count = count;
    }
    toProto() {
        return { skip: this.count };
    }
}
//# sourceMappingURL=SkipStage.js.map